import InfoIcon from "@/components/icons/InfoIcon";
import Panel from "@/components/Panel";
import DOMPurify from "dompurify";
import {parseMergeTags} from "@/helpers";
import {useAppState} from "@/store";

export default function Information() {

    const content = window.ein?.content?.step_5 || {}
    const {state} = useAppState()

    const {info_block} = content

    return (
        <Panel passive={true} feature={true}>
            <div className={"flex [&>:last-child]:mb-0"}>
                <InfoIcon className={"shrink-0 size-[32px] mr-[12px]"}/>
                <div
                    className={"text-small [&>*]:text-small [&>*:last-child]:mb-0"}
                    dangerouslySetInnerHTML={{'__html': DOMPurify.sanitize(parseMergeTags(info_block?.text, state))}}
                />
            </div>
        </Panel>
    )
}
